module.exports = __webpack_public_path__ + "6b668eda4b674eeec22355fbd6ab27e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/visa_2022_chart.png
// module id = 1759
// module chunks = 0